var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"slide-fade"}},[(_vm.$store.state.simplePreloader && !_vm.$store.state.preloader)?_c('div',{staticClass:"simple-preloader"},[_c('img',{attrs:{"src":require("@/assets/logo.png")}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }